
import React, { useContext } from "react";
import { AppContext } from "../../../../appContext";
import { ISideMenuRouteProps } from "./ISideMenuRouteProps";
import { PopupWrapper } from "../../../../components/styled/BasicBlocks";
import { SideMenuCommonHeader } from "./SideMenuCommon";
import "./SideMenuQuickstart.css";
// import kitsugiVideo from "../../../../assets/kitsugi_onboarding.mp4";
import coverImage from "../../../../assets/cover.jpeg";

export const SideMenuQuickstart = ({ onClose }: ISideMenuRouteProps) => {
    const { translate } = useContext(AppContext);
    
    const renderSection = (title: string, content: string, stepNumber: number) => (
        <div className="SideMenuQuickstart_section">
            <div className="SideMenuQuickstart_sectionHeader">
                <div className="SideMenuQuickstart_stepNumber">{stepNumber}</div>
                <h3 className="SideMenuQuickstart_sectionTitle">{title}</h3>
            </div>
            <div className="SideMenuQuickstart_sectionContent">
                {content.split('\n').map((line, index) => {
                    // Handle bold text for important terms
                    if (line.includes('—')) {
                        const [term, description] = line.split('—');
                        return (
                            <p key={index}>
                                <strong>{term}</strong> — {description}
                            </p>
                        );
                    }
                    // Handle bullet points
                    if (line.trim().startsWith('•') || line.includes('плюс') || line.includes('plus')) {
                        return (
                            <div key={index} className="SideMenuQuickstart_bulletPoint">
                                <span className="SideMenuQuickstart_bullet">💡</span>
                                <span>{line.replace(/^•\s*/, '')}</span>
                            </div>
                        );
                    }
                    // Handle action items
                    if (line.includes('нажмите') || line.includes('click') || line.includes('заполните') || line.includes('fill')) {
                        return (
                            <div key={index} className="SideMenuQuickstart_actionItem">
                                <span className="SideMenuQuickstart_actionIcon">👆</span>
                                <span>{line}</span>
                            </div>
                        );
                    }
                    return line ? <p key={index}>{line}</p> : null;
                })}
            </div>
        </div>
    );
    
    return <PopupWrapper className="SideMenuQuickstart">
        <SideMenuCommonHeader text={translate('sideMenu_quickstart')} onClose={onClose}>
        </SideMenuCommonHeader>
        <div className="SideMenuQuickstart_content">
            <div className="SideMenuQuickstart_welcome">
                <h1>{translate('quickstart_content_welcome')}</h1>
                <p>{translate('quickstart_content_descr')}</p>
            </div>

            <div className="sideMenuQuickstart_video">
                <video
                    controls
                    preload="metadata"
                    poster={coverImage}
                    width="100%"
                    style={{ maxWidth: '500px', borderRadius: '8px' }}
                >
                    <source src="https://s3.eu-north-1.amazonaws.com/kitsugi.app/media/kitsugi.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>

            {renderSection(translate('quickstart_content_1'), translate('quickstart_content_1_text'), 1)}

            {renderSection(translate('quickstart_content_2'), translate('quickstart_content_2_text'), 2)}

            {renderSection(translate('quickstart_content_3'), translate('quickstart_content_3_text'), 3)}

            {renderSection(translate('quickstart_content_4'), translate('quickstart_content_4_text'), 4)}

            <div className="SideMenuQuickstart_completion">
                <h2>{translate('quickstart_done')}</h2>
                <p>{translate('quickstart_done_descr')}</p>
            </div>
        </div>
    </PopupWrapper>
}
